import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //.js-switch-event on change
        let switchEvent = document.querySelector('.js-switch-event');
        if(!switchEvent) return;

        let data = this.el.getAttribute('data-events');
        data = JSON.parse(data);

        switchEvent.addEventListener('change', (e) => {
            let newEvent = data[data.findIndex((event) => event.id == e.target.value)];
            //update .js-event-hour with 
            if(document.querySelector('.js-event-hour')) document.querySelector('.js-event-hour').innerHTML = newEvent.dates_format.hour;
            let prices = document.querySelector('.js-event-prices');
            prices.innerHTML = '';
            newEvent.formatted_prices.forEach(price => {
                if(price.zone != 'Parterre') return;
                let priceEl = document.createElement('div');
                priceEl.classList.add('o-fold-event__buy__item');
                let priceText = price.montant;
                if(price.montant == 0) {
                    priceText = 'Gratuit';
                } else {
                    priceText = price.montant + '<sup>$</sup>';
                }
                priceEl.innerHTML = `
                    <div class="o-fold-event__buy__item__title">${price.categorie}</div>
                    <div class="o-fold-event__buy__item__price">${priceText}</div>
                `;
                prices.appendChild(priceEl);
            });

            let tag = newEvent.tag;
            let buyTicket = document.querySelector('.js-buy-ticket');
            if(tag && tag.complet){
                //Change the markup of the buy ticket button
                buyTicket.innerHTML = `
                    <button class="o-button js-buy-ticket is-disabled" disabled="" aria-label="Représentation complète">
                        <span class="o-button__text">Complet</span>
                        <span class="sr-only">Représentation complète</span>
                        <svg aria-hidden="true" focusable="false" class="o-ico ">
                            <use xlink:href="${WPURLS.stylesheet_directory}/assets/img/sprite.svg?v=${RESOURCE_REVISION.v}#ticket"></use>
                        </svg>
                    </button>
                `;
            } else if(tag && tag.reporte){
                //Change the markup of the buy ticket button
                buyTicket.innerHTML = `
                    <button class="o-button js-buy-ticket is-disabled" disabled="" aria-label="Représentation reportée">
                        <span class="o-button__text">Reporté</span>
                        <span class="sr-only">Représentation reportée</span>
                        <svg aria-hidden="true" focusable="false" class="o-ico ">
                            <use xlink:href="${WPURLS.stylesheet_directory}/assets/img/sprite.svg?v=${RESOURCE_REVISION.v}#ticket"></use>
                        </svg>
                    </button>
                `;
            } else if(tag && tag.annule){
                //Change the markup of the buy ticket button
                buyTicket.innerHTML = `
                    <button class="o-button js-buy-ticket is-disabled" disabled="" aria-label="Représentation annulée">
                        <span class="o-button__text">Annulé</span>
                        <span class="sr-only">Représentation annulée</span>
                        <svg aria-hidden="true" focusable="false" class="o-ico ">
                            <use xlink:href="${WPURLS.stylesheet_directory}/assets/img/sprite.svg?v=${RESOURCE_REVISION.v}#ticket"></use>
                        </svg>
                    </button>
                `;
            } else {
                // Check if the event is free (all prices are 0)
                const isFree = newEvent.formatted_prices.every(price => parseFloat(price.montant) == 0);
                const buttonText = isFree ? 'Réserver' : 'Acheter';
                const accessibilityText = isFree ? 'Réserver des billets' : 'Acheter des billets';
                
                buyTicket.innerHTML = `
                    <a class="o-button" href="${newEvent.fields.url_achat}" target="_blank" aria-label="${accessibilityText}" rel="noopener noreferrer">
                        <span class="o-button__text">${buttonText}</span>
                        <span class="sr-only">${accessibilityText}</span>
                        <svg aria-hidden="true" focusable="false" class="o-ico ">
                            <use xlink:href="${WPURLS.stylesheet_directory}/assets/img/sprite.svg?v=${RESOURCE_REVISION.v}#ticket"></use>
                        </svg>
                    </a>
                `;
            }
        });

        //add class is-active on first .js-event-date
        let firstEventDate = document.querySelector('.js-event-date');
        if(firstEventDate) {
            firstEventDate.classList.add('is-active');
        }

        //add event listeners click on all .js-event-date
        let eventDates = document.querySelectorAll('.js-event-date');
        eventDates.forEach(eventDate => {
            eventDate.addEventListener('click', (e) => {
                let eventDate = e.target;
                //Get the closest element with data-event-id
                while(!eventDate.getAttribute('data-event-id')) {
                    eventDate = eventDate.parentElement;
                }
                let event = data[data.findIndex((event) => event.id == eventDate.getAttribute('data-event-id') )];
                //update .js-event-hour with 
                if(document.querySelector('.js-event-hour')) document.querySelector('.js-event-hour').innerHTML = event.dates_format.hour;
                let prices = document.querySelector('.js-event-prices');
                prices.innerHTML = '';
                event.formatted_prices.forEach(price => {
                    if(price.zone != 'Parterre') return;
                    let priceEl = document.createElement('div');
                    priceEl.classList.add('o-fold-event__buy__item');
                    let priceText = price.montant;
                    if(price.montant == 0) {
                        priceText = 'Gratuit';
                    } else {
                        priceText = price.montant + '<sup>$</sup>';
                    }
                    priceEl.innerHTML = `
                        <div class="o-fold-event__buy__item__title">${price.categorie}</div>
                        <div class="o-fold-event__buy__item__price">${priceText}</div>
                    `;
                    prices.appendChild(priceEl);
                });

                //Remove is-active class on all .js-event-date and add it to the clicked one
                eventDates.forEach(eventDate => {
                    eventDate.classList.remove('is-active');
                });
                eventDate.classList.add('is-active');

                //Update select
                let switchEvent = document.querySelector('.js-switch-event');
                switchEvent.value = event.id;

                //update js-buy-ticket
                let tag = event.tag;
                let buyTicket = document.querySelector('.js-buy-ticket');
                if(tag && tag.complet){
                    //Change the markup of the buy ticket button
                    buyTicket.innerHTML = `
                        <button class="o-button js-buy-ticket is-disabled" disabled="" aria-label="Représentation complète">
                            <span class="o-button__text">Complet</span>
                            <span class="sr-only">Représentation complète</span>
                            <svg aria-hidden="true" focusable="false" class="o-ico ">
                                <use xlink:href="${WPURLS.stylesheet_directory}/assets/img/sprite.svg?v=${RESOURCE_REVISION.v}#ticket"></use>
                            </svg>
                        </button>
                    `;
                } else if(tag && tag.reporte){
                    //Change the markup of the buy ticket button
                    buyTicket.innerHTML = `
                        <button class="o-button js-buy-ticket is-disabled" disabled="" aria-label="Représentation reportée">
                            <span class="o-button__text">Reporté</span>
                            <span class="sr-only">Représentation reportée</span>
                            <svg aria-hidden="true" focusable="false" class="o-ico ">
                                <use xlink:href="${WPURLS.stylesheet_directory}/assets/img/sprite.svg?v=${RESOURCE_REVISION.v}#ticket"></use>
                            </svg>
                        </button>
                    `;
                } else if(tag && tag.annule){
                    //Change the markup of the buy ticket button
                    buyTicket.innerHTML = `
                        <button class="o-button js-buy-ticket is-disabled" disabled="" aria-label="Représentation annulée">
                            <span class="o-button__text">Annulé</span>
                            <span class="sr-only">Représentation annulée</span>
                            <svg aria-hidden="true" focusable="false" class="o-ico ">
                                <use xlink:href="${WPURLS.stylesheet_directory}/assets/img/sprite.svg?v=${RESOURCE_REVISION.v}#ticket"></use>
                            </svg>
                        </button>
                    `;
                } else {
                    // Check if the event is free (all prices are 0)
                    const isFree = event.formatted_prices.every(price => parseFloat(price.montant) == 0);
                    const buttonText = isFree ? 'Réserver' : 'Acheter';
                    const accessibilityText = isFree ? 'Réserver des billets' : 'Acheter des billets';
                    
                    buyTicket.innerHTML = `
                        <a class="o-button" href="${event.fields.url_achat}" target="_blank" aria-label="${accessibilityText}" rel="noopener noreferrer">
                            <span class="o-button__text">${buttonText}</span>
                            <span class="sr-only">${accessibilityText}</span>
                            <svg aria-hidden="true" focusable="false" class="o-ico ">
                                <use xlink:href="${WPURLS.stylesheet_directory}/assets/img/sprite.svg?v=${RESOURCE_REVISION.v}#ticket"></use>
                            </svg>
                        </a>
                    `;
                }

                //SCroll to .js-event-hour
                let eventHour = document.querySelector('.js-scoll-to-fold');
                let offset = document.documentElement.dataset.scrollDefaultOffset? document.documentElement.dataset.scrollDefaultOffset:0;
                window.locomotiveScroll.scrollTo(eventHour, { offset: parseInt(offset), duration: 1 });
            });
        });

    }

   

    destroy() {
        // Remove event listeners
        let switchEvent = document.querySelector('.js-switch-event');
        if(!switchEvent) return;
        switchEvent.removeEventListener('change', (e) => {
            let newEvent = data[data.findIndex((event) => event.id == e.target.value)];
            //update .js-event-hour with 
            if(document.querySelector('.js-event-hour')) document.querySelector('.js-event-hour').innerHTML = newEvent.dates_format.hour;
            let prices = document.querySelector('.js-event-prices');
            prices.innerHTML = '';
            let priceText = price.montant;
            if(price.montant == 0) {
                priceText = 'Gratuit';
            } else {
                priceText = price.montant + '<sup>$</sup>';
            }
            newEvent.formatted_prices.forEach(price => {
                if(price.zone != 'Parterre') return;
                let priceEl = document.createElement('div');
                priceEl.classList.add('o-fold-event__buy__item');
                priceEl.innerHTML = `
                    <div class="o-fold-event__buy__item__title">${price.categorie}</div>
                    <div class="o-fold-event__buy__item__price">${priceText}</div>
                `;
                prices.appendChild(priceEl);
            });
        });
    }
}